import { render } from "./HabitantRel.vue?vue&type=template&id=295435e1"
import script from "./HabitantRel.vue?vue&type=script&lang=js"
export * from "./HabitantRel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__